import { useAlertContext } from '@/routes/suba/common/contexts/AlertContext';
import { LinearProgress, Stack } from '@mui/material';

import { DisbursementActions } from './components/DisbursementActions.component';
import { DisbursementDestinations } from './components/DisbursementDestinations.component';
import { DisbursementDetails } from './components/DisbursementDetails.component';
import { DisbursementInformation } from './components/DisbursementInformation.component';
import { DisbursementNotes } from './components/DisbursementNotes.component';

export const DisbursementExpandedAlertDetails = () => {
  const alert = useAlertContext();

  if (!alert) return <LinearProgress />;

  return (
    <Stack spacing={2}>
      <DisbursementActions />
      <DisbursementDetails />
      <DisbursementNotes />
      <DisbursementDestinations />
      <DisbursementInformation />
    </Stack>
  );
};
